import { Link } from 'react-router-dom';

/**
 * Short crypto/RLUSD payout disclaimer. Shown on the affiliate program page so the
 * key risk points are visible before anyone signs up.
 */
export function PayoutDisclaimer() {
  return (
    <div className="payout-disclaimer">
      <span className="payout-disclaimer__label">RLUSD Payout Disclaimer</span>
      <p className="prose prose--sm prose--muted" style={{ margin: 0 }}>
        Commissions are calculated in USD and paid in RLUSD, a US-dollar stablecoin on the XRP Ledger
        intended to hold a 1:1 value with the US dollar. RLUSD is issued by a third party (Ripple); GRID
        does not control or guarantee its value, its peg, or its availability. You are responsible for
        providing a correct XRPL wallet address with an RLUSD trustline — payments sent to an address you
        provide are considered made — and for any taxes on amounts you receive. This is not financial,
        investment, or tax advice, and nothing here is an offer of a security or investment. See the{' '}
        <Link to="/affiliate-terms" style={{ color: 'var(--accent)' }}>Affiliate Agreement</Link> and{' '}
        <Link to="/terms" style={{ color: 'var(--accent)' }}>Terms of Service</Link> for full details.
      </p>
    </div>
  );
}
